import React from 'react';

export default function UnifiedChatHeader({ styles, title, subtitle }) {
  return (
    <div style={{ ...styles.header }}>
      <div style={{ ...styles.headerTitle }}>{title}</div>
      <div style={{ ...styles.headerSub }}>{subtitle}</div>
    </div>
  );
}
